import React from 'react';
import CMPImage from 'components/global/image';

const CharacterIcon: React.FunctionComponent = () => {
  const src = '/images/character.png';
  return <CMPImage asset={{ src, alt: 'Character' }} width={16} height={18} />;
};
export default CharacterIcon;
